import { styled } from "goober";
import { Link } from "./Link";
import { PressButton } from "./PressButton";

const styles = `
  display: flex;
  flex-shrink: 0;
  align-items: center;
  border: none;
  outline: none;
  gap: 6px;
  padding: 8px 12px;
  border-radius: 24px;
  cursor: pointer;
  color: var(--text-secondary);
  background: var(--surface-primary);

  &:hover,
  &.active {
    color: var(--text-primary);
    background:
      linear-gradient(var(--alpha4), var(--alpha4)), var(--surface-primary);
  }
`;

export const TabButton = styled(PressButton)`
  ${styles}
`;

export const TabLinkButton = styled(Link)`
  ${styles}
  text-decoration: none;
`;
